import VaWorksApi from './VaWorksApi'

export const authenticationService = {
  login
}

function login (email, password) {
  return VaWorksApi().post('/Authentication', { email, password })
}



// WEBPACK FOOTER //
// ./src/api/auth.service.js